// @flow
import React, { PureComponent } from "react";
import classNames from "classnames";

type Props = {
  height: number,
  width: number,
  className: any
};

class TextXl extends PureComponent<Props> {
  render() {
    const { height, width, className } = this.props;
    const classes = classNames("icone", className);

    return (
      <svg className={classes} height={height} width={width} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
        <title>Texto</title>
        <desc>Representação de linhas de texto</desc>
        <g id="icon-text-xl">
          <path d="M1,3H63a1,1,0,0,0,0-2H1A1,1,0,0,0,1,3Z" />
          <path d="M63,7H1A1,1,0,0,0,1,9H63a1,1,0,0,0,0-2Z" />
          <path d="M1,15H36a1,1,0,0,0,0-2H1a1,1,0,0,0,0,2Z" />
          <path d="M63,19H1a1,1,0,0,0,0,2H63a1,1,0,0,0,0-2Z" />
          <path d="M63,25H1a1,1,0,0,0,0,2H63a1,1,0,0,0,0-2Z" />
          <path d="M1,33H36a1,1,0,0,0,0-2H1a1,1,0,0,0,0,2Z" />
          <path d="M63,37H1a1,1,0,0,0,0,2H63a1,1,0,0,0,0-2Z" />
          <path d="M63,43H1a1,1,0,0,0,0,2H63a1,1,0,0,0,0-2Z" />
          <path d="M63,55H1a1,1,0,0,0,0,2H63a1,1,0,0,0,0-2Z" />
          <path d="M36,61H1a1,1,0,0,0,0,2H36a1,1,0,0,0,0-2Z" />
          <path d="M1,51H36a1,1,0,0,0,0-2H1a1,1,0,0,0,0,2Z" />
        </g>
      </svg>
    );
  }
}

export default TextXl;
